/**
 * LocalStorage key constants
 * Use these constants to avoid hardcoded strings throughout the frontend
 */

/**
 * AI Training localStorage keys
 */
export const LOCAL_STORAGE_KEYS = {
  AI_TRAINING: {
    LAST_AUDIT_TYPE: 'ai-training-last-audit-type',
    LAST_SECTION: 'ai-training-last-section',
    PROMPT_PREFIX: 'ai-prompt',
    MODEL_PREFIX: 'ai-model',
  },
} as const

/**
 * Helper function to generate AI training localStorage keys
 */
export const getAITrainingStorageKeys = (auditType: string, sectionKey: string) => ({
  prompt: `${LOCAL_STORAGE_KEYS.AI_TRAINING.PROMPT_PREFIX}-${auditType}-${sectionKey}`,
  model: `${LOCAL_STORAGE_KEYS.AI_TRAINING.MODEL_PREFIX}-${auditType}-${sectionKey}`,
})
